import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Section, Eyebrow, H2, GlassCard } from "../components/site/Primitives";
import { useAuth } from "../lib/auth";
import { ArrowRight } from "lucide-react";

const ROLES = [
  { v: "guest", l: "Guest / Visitor" },
  { v: "investor", l: "Investor" },
  { v: "resident", l: "Veteran Housing Resident" },
  { v: "tenant", l: "Tenant" },
  { v: "contractor", l: "Contractor / Vendor" },
  { v: "property_manager", l: "Property Manager" },
  { v: "employee", l: "220 Employee" },
];

export default function Register() {
  const nav = useNavigate();
  const { register } = useAuth();
  const [f, setF] = useState({ name: "", email: "", password: "", role: "guest" });
  const submit = async (e) => {
    e.preventDefault();
    try { await register(f); toast.success("Account created."); nav("/portal"); }
    catch (err) { toast.error(err?.response?.data?.detail || "Could not register."); }
  };
  return (
    <Section className="pt-40 max-w-xl">
      <Eyebrow>Create Account</Eyebrow>
      <H2>Join the 220 Inc. platform.</H2>
      <GlassCard className="p-8 mt-10">
        <form onSubmit={submit} className="space-y-4" data-testid="register-form">
          <In label="Full Name *" value={f.name} required onChange={(e) => setF({ ...f, name: e.target.value })} testid="reg-name" />
          <In label="Email *" type="email" value={f.email} required onChange={(e) => setF({ ...f, email: e.target.value })} testid="reg-email" />
          <In label="Password *" type="password" minLength={6} value={f.password} required onChange={(e) => setF({ ...f, password: e.target.value })} testid="reg-password" />
          <label className="block">
            <span className="block text-xs uppercase tracking-[0.18em] text-white/50 mb-2">Role</span>
            <select value={f.role} onChange={(e) => setF({ ...f, role: e.target.value })} className="w-full bg-[#0e0e10] border border-white/10 px-3 py-3 text-white text-sm focus:outline-none focus:border-gold" data-testid="reg-role">
              {ROLES.map((r) => <option key={r.v} value={r.v}>{r.l}</option>)}
            </select>
          </label>
          <button type="submit" className="btn-primary w-full justify-center" data-testid="register-submit">Create Account <ArrowRight size={14} /></button>
        </form>
        <div className="mt-6 text-sm text-white/60">Already have an account? <Link to="/login" className="text-gold">Sign in</Link></div>
      </GlassCard>
    </Section>
  );
}

function In({ label, testid, ...props }) {
  return (
    <label className="block">
      <span className="block text-xs uppercase tracking-[0.18em] text-white/50 mb-2">{label}</span>
      <input className="w-full bg-[#0e0e10] border border-white/10 px-3 py-3 text-white text-sm focus:outline-none focus:border-gold" data-testid={testid} {...props} />
    </label>
  );
}
